export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_MAXIMUM_PAGE_SIZE = -1;
export const INITIAL_PAGE = 1;

export const ACCESS_TOKEN = "access_token";
export const LANGUAGE_CODE = "i18nextLng";

export const DATE_FORMATE = "DD-MM-YYYY, LT";
export const MAP_DEFAULT_ZOOM = 14;

// @react-google-maps/api shares ONE global Loader across the whole app, and
// every useJsApiLoader call must pass an identical `libraries` array — otherwise
// the Loader throws "Loader must not be called again with different options".
// Import THIS single constant in every map component so the array content is
// always the same. "geometry" is required by the trip route map; including it
// everywhere is additive and harmless for components that don't use it.
export const GOOGLE_MAPS_LIBRARIES: ("drawing" | "geometry")[] = [
  "drawing",
  "geometry",
];

export const DEFAULT_FUNCTION = () => null;
export const DEFAULT_QUERY = {
  page: INITIAL_PAGE,
  perPage: DEFAULT_PAGE_SIZE,
};

export const MAP_DEFAULT_LOCATION = {
  lat: 33.513872588881014,
  lng: 36.27664584020132,
};
export const languages = [
  {
    code: "ar",
    name: "العربية",
    isMain: true,
  },
  {
    code: "en",
    name: "English",
    isMain: true,
  },
];

const getDefaultTranslations = () => {
  const obj: any = {};
  languages.forEach((l) => (obj[l.code] = null));
  return obj;
};
export const DEFAULT_TRANSLATIONS = getDefaultTranslations();

export const checkTranslations = (data: any) => {
  const s1 = Object.keys(DEFAULT_TRANSLATIONS);
  const s2 = Object.keys(data);
  let check = true;
  s1.forEach((item) => {
    if (!s2.includes(item)) {
      check = false;
    }
  });
  return check;
};

export const checkObjectTranslations = (data: any) => {
  const s1 = Object.values(data);
  let check = false;

  s1.forEach((item) => {
    if (item) {
      check = true;
    }
  });
  return check;
};

export const checkObjectValuesTranslations = (data: any) => {
  const s1 = Object.values(data);

  let check = true;

  if (checkTranslations(data) === true) {
    s1.forEach((item) => {
      if (!item) {
        check = false;
      }
    });
  } else {
    check = false;
  }

  return check;
};
